var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('fa-icon',{attrs:{"icon":_vm.iconWithScope}}),_vm._v(" "),(_vm.text)?_c('span',{staticClass:"fa5-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }